"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FeatureFlagsProvider } from "../contexts/FeatureFlagsContext.js";
import { StripeRedirectHandler } from "./StripeRedirectHandler.js";
/**
 * AnyspendProvider is a top-level provider that wraps your application to provide
 * query caching and state management for all Anyspend hooks.
 *
 * Features:
 * - Memoized QueryClient instance to prevent unnecessary re-renders
 * - Optimized for performance with React.memo
 * - Safe to use at the application root
 * - Configures sensible defaults for query caching
 * - Handles Stripe payment redirects and modal state
 * - Provides feature flags configuration
 *
 * @example
 * ```tsx
 * function App() {
 *   return (
 *     <AnyspendProvider featureFlags={{ showPoints: true }}>
 *       <YourApp />
 *     </AnyspendProvider>
 *   );
 * }
 * ```
 */
export const AnyspendProvider = function AnyspendProvider({ children, featureFlags }) {
    return (_jsxs(FeatureFlagsProvider, { featureFlags: featureFlags, children: [_jsx(StripeRedirectHandler, {}), children] }));
};
